export default "__VITE_ASSET__79a26879__"